import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  setup(nuxtApp) {
    const config = nuxtApp.$config;

    Sentry.init({
      app: nuxtApp.vueApp,
      enabled: !['development', 'test'].includes(config.public.applicationEnv),
      dsn: config.public.sentry.fakeDsn,
      tunnel: '/api/sentry',
      environment: config.public.applicationEnv,
      release: config.app.buildId,

      // Disable "browserSessionIntegration"
      integrations: function (integrations) {
        return integrations.filter(
          (integration) => !['BrowserTracing', 'BrowserSession'].includes(integration.name)
        );
      },

      tracePropagationTargets: ['localhost', config.public.baseUrl as string],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1,
      sendClientReports: false,
      debug: false,
    });
  },
});
